<ng-container *ngIf="action && visible">
  <button nz-button [nzType]="nzType" [nzSize]="size" [nzShape]="shape" [nzLoading]="action?.inProgress"
    [disabled]="disabled || form?.busy" (click)="activate()" class="mr-3 mb-3">
    <i *ngIf="!action?.inProgress" class="{{icon}}"></i>&nbsp;&nbsp;{{showLabel ? action?.actionName : ''}}
  </button>
</ng-container>
